<ng-container *ngIf="isSidebarManagedMode && !fileName; else defaultUploadLayouts">
  <div class="upload-desktop-card-layout-stripe" [ngClass]="{ sm: isSm }">
    <div
      class="upload-desktop-card error empty w-auto"
      role="button"
      tabindex="0"
      (click)="onFooterHintClicked($event)"
      (keydown.enter)="onFooterHintKeydown($event)"
      (keydown.space)="onFooterHintKeydown($event)"
    >
      <span class="upload-desktop-card-header-and-body">
        <span
          class="upload-desktop-card-body"
          [ngClass]="{
            uploaded: fileName
          }"
        >
          <span class="upload-desktop-card-header-and-body-main">
            <span class="upload-desktop-card-icon" [ngClass]="{ sm: isSm }">
              <i class="fa paperclip fa-paperclip" aria-hidden="true"></i>
            </span>

            <span class="upload-desktop-card-description-text">
              <span class="upload-desktop-card-header">
                <span class="upload-desktop-card-header-type-name">
                  {{ attachmentName || attachmentTypeName | translate }}
                </span>
                <span class="upload-desktop-card-header-required" *ngIf="isRequired && !isSm">
                  {{ "LABELS.REQUIRED" | translate }}
                </span>
              </span>

              <span
                class="document-id d-none d-md-flex"
                *ngIf="(attachmentName || attachmentHint) && !isSm"
                [innerHTML]="attachmentHint || attachmentName | translate"
              ></span>
            </span>
          </span>

          <span
            class="upload-desktop-card-aside d-none d-md-flex"
            *ngIf="(canUploadDocuments || !!footerHintAction) && !isShowEmptyFileTag"
          >
            <span
              class="upload-desktop-card-aside__text"
              [class.upload-desktop-card-aside__text--action]="!!footerHintAction"
              [innerHTML]="footerHint | translate"
            ></span>
            <app-hint-tooltip-icon [hint]="attachmentManagedTooltip" *ngIf="!!attachmentManagedTooltip"></app-hint-tooltip-icon>
          </span>

          <span class="upload-desktop-card-aside-empty" *ngIf="isShowEmptyFileTag">
            <span [innerHTML]="'LABELS.NOT_AVAILABLE_YET' | translate"></span>
          </span>
        </span>
      </span>
    </div>
  </div>
</ng-container>

<ng-template #defaultUploadLayouts>
  <ng-container *ngIf="isSimpleStripLayout">
    <ng-content *ngTemplateOutlet="simpleStripLayout"></ng-content>
  </ng-container>

  <ng-container *ngIf="isStripeLayout && !(forceMobileView || (isTablet$ | async))">
    <ng-content *ngTemplateOutlet="stripeLayout"></ng-content>
  </ng-container>

  <ng-container *ngIf="isDividedLayout && !(forceMobileView || (isTablet$ | async))">
    <ng-content *ngTemplateOutlet="dividedLayout"></ng-content>
  </ng-container>

  <ng-container *ngIf="isDividedLayout && (forceMobileView || (isTablet$ | async))">
    <ng-content *ngTemplateOutlet="mobileDividedLayout"></ng-content>
  </ng-container>

  <ng-container *ngIf="!isStripeLayout && !isDividedLayout && !isSimpleStripLayout && !(forceMobileView || (isTablet$ | async))">
    <ng-content *ngTemplateOutlet="boxLayout"></ng-content>
  </ng-container>

  <ng-container *ngIf="!isDividedLayout && !isSimpleStripLayout && (forceMobileView || (isTablet$ | async))">
    <ng-content *ngTemplateOutlet="mobileBoxLayout"></ng-content>
  </ng-container>

  <ng-template #simpleStripLayout>
    <div
      class="upload-desktop-card__simple-strip-layout"
      [ngClass]="{
        'is-uploaded': isDocumentUploaded,
        'is-loading': isLoading || isDocumentScanPending || isUploadingDoc,
        'full-error-highlight': isShowFullErrorHighlight || (fileControl.invalid && isFullErrorHighlight),
        'is-drag-over': isDragOver
      }"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
      (dragleave)="onDragLeave($event)"
    >
      <loading-spinner [show]="isLoading && isRemovingDoc"></loading-spinner>
      <div class="upload-desktop-card__simple-strip-layout__main">
        <!-- Uploading Icon Animation -->
        <div
          *ngIf="(isLoading || isDocumentScanPending || isUploadingDoc) && !isRemovingDoc && !isDocumentUploaded"
          class="upload-desktop-card__simple-strip-layout__upload-loader"
        >
          <div class="upload-desktop-card__simple-strip-layout__upload-loader__inner-container">
            <border-spinner loaderClass="xs-loader"></border-spinner>
            <img class="upload-desktop-card__simple-strip-layout__upload-loader__add-icon" src="assets/icons/icon_add_lg.svg" alt="add" />
          </div>
        </div>

        <!-- Uploaded Icon -->
        <div *ngIf="isDocumentUploaded" class="upload-desktop-card__simple-strip-layout__status">
          <img src="/assets/icons/icon_circled_check_green.svg" alt="status" />
        </div>

        <div class="upload-desktop-card__simple-strip-layout__content">
          <div class="upload-desktop-card__simple-strip-layout__header">
            <p class="upload-desktop-card__simple-strip-layout__title">{{ attachmentName | translate }}</p>

            <span class="upload-desktop-card__simple-strip-layout__required-tag" *ngIf="isRequired && !fileName && !isHideTag">
              {{ "LABELS.REQUIRED" | translate }}
            </span>
            <span
              class="upload-desktop-card__simple-strip-layout__deferred-required-tag"
              *ngIf="isShowDeferredRequiredTag && !fileName && !isRequired"
            >
              {{ "LABELS.REQUIRED_LATER" | translate }}
              <app-hint-tooltip-icon *ngIf="requiredLaterTooltip" [hint]="requiredLaterTooltip | translate"></app-hint-tooltip-icon>
            </span>
            <span
              class="upload-desktop-card__simple-strip-layout__optional-tag"
              *ngIf="isShowOptionalTag && !fileName && !isRequired && !isHideTag"
            >
              {{ "LABELS.OPTIONAL" | translate }}
            </span>
          </div>

          <p
            *ngIf="!isDocumentUploaded && isAttachmentHintHtml"
            class="upload-desktop-card__simple-strip-layout__subtitle"
            [innerHTML]="attachmentHint | translate"
          ></p>

          <p *ngIf="!isDocumentUploaded && !isAttachmentHintHtml" class="upload-desktop-card__simple-strip-layout__subtitle">
            {{ attachmentHint | translate }}
            <span *ngIf="!!attachmentHintNote" class="upload-desktop-card__simple-strip-layout__subtitle bold-weight">
              {{ attachmentHintNote | translate }}
            </span>
          </p>

          <div *ngIf="isShowFullErrorHighlight" class="upload-desktop-card__simple-strip-layout__errors-container">
            <span *ngIf="isDocumentScanFailed" class="text-error small">
              {{ "DOCUMENTS.SCAN_FAILED" | translate }}
            </span>
            <span *ngIf="isDocumentFailedAfterScan" class="text-error small">
              {{ "BACK_ERROR.FILE_SIZE_TO_BIG_AFTER_SCAN" | translate }}
            </span>
          </div>

          <div class="upload-desktop-card__simple-strip-layout__errors-container" *ngIf="fileControl.invalid && isFullErrorHighlight">
            <app-control-errors
              [errors]="errors"
              [control]="fileControl"
              controlClass="text-error small text-left"
              [isShowHelper]="false"
            ></app-control-errors>
          </div>

          <span *ngIf="isDocumentUploaded" [class]="'document-file-name ' + documentFileNameBtnClass">
            <button type="button" class="btn btn-link text-left text-decoration-underline" (click)="downloadDocument()">
              {{ fileName }}
            </button>
            <a #link class="d-none" download></a>
          </span>
          <ng-content select="[extra-content]"></ng-content>
        </div>

        <div *ngIf="isDocumentUploaded" class="upload-desktop-card__simple-strip-layout__create-date-container">
          <span *ngIf="isShowLabelOverUploadedDate" class="upload-desktop-card__simple-strip-layout__create-date-container__label">
            {{ "DOCUMENT_STATE.UPLOADED" | translate }}
          </span>
          <span>{{ uploadedDocument?.uploadedDate || uploadedDocument?.createdDate | customDateByUtc }}</span>
        </div>

        <div class="upload-desktop-card__simple-strip-layout__actions" [ngClass]="{ uploaded: isDocumentUploaded }">
          <button
            *ngIf="!isDocumentUploaded && !isCustomBrowseBtn"
            (click)="uploadClick()"
            [disabled]="isLoading || isDocumentScanPending || isUploadingDoc"
            class="upload-desktop-card__simple-strip-layout__actions__browse-btn btn btn-outline-secondary btn-square btn-sm"
          >
            {{ "LABELS.BROWSE" | translate }}
          </button>

          <ng-content select="[custom-browse-btn]"></ng-content>

          <img
            *ngIf="isDocumentUploaded && canViewDocuments"
            class="upload-desktop-card-icon"
            [ngClass]="{ disabled: !uploadedDocument?.previewDocumentId }"
            (click)="viewFile($event)"
            src="assets/icons/eye_gray.svg"
          />

          <img
            *ngIf="isDocumentUploaded && canDownloadDocuments"
            class="upload-desktop-card-icon"
            [disabled]="!isDocumentUploaded"
            (click)="downloadDocument()"
            src="assets/icons/icon_download_gray_md.svg"
          />

          <img
            *ngIf="isDocumentUploaded && canRemoveDocuments"
            class="upload-desktop-card-icon"
            (click)="removeFile($event)"
            src="assets/icons/icon_trash.svg"
          />
        </div>
      </div>

      <div
        *ngIf="(isDocumentScanFailed || isDocumentFailedAfterScan) && !isFullErrorHighlight"
        class="upload-desktop-card__simple-strip-layout__errors-container"
      >
        <span *ngIf="isDocumentScanFailed" class="text-error small">
          {{ "DOCUMENTS.SCAN_FAILED" | translate }}
        </span>
        <span *ngIf="isDocumentFailedAfterScan" class="text-error small">
          {{ "BACK_ERROR.FILE_SIZE_TO_BIG_AFTER_SCAN" | translate }}
        </span>
      </div>

      <div class="upload-desktop-card__simple-strip-layout__errors-container" *ngIf="fileControl.invalid && !isFullErrorHighlight">
        <app-control-errors [errors]="errors" [control]="fileControl" controlClass="text-error" [isShowHelper]="false"></app-control-errors>
      </div>
    </div>

    <span
      class="upload-desktop-card-link mt-2 d-block pl-0"
      *ngIf="
        (!isHidePoaDownload &&
          [enumDocumentType.POWER_OF_ATTORNEY, enumDocumentType.POWER_OF_ATTORNEY_TRUCKER].includes(uploadedDocument?.type)) ||
        (isShowDownloadFile && !isDocumentUploaded)
      "
    >
      <a [href]="poaFileUrl" target="_blank" download>
        <span class="upload-desktop-card-download-icon-container">
          <icon-download></icon-download>
        </span>
        {{ "BUTTON.DOWNLOAD_POA_FORM_POA" | translate }}
      </a>
    </span>
  </ng-template>

  <ng-template #stripeLayout>
    <div class="upload-desktop-card-layout-stripe" [ngClass]="{ sm: isSm }">
      <label
        class="upload-desktop-card"
        [for]="id"
        [ngClass]="{
          empty: !fileName,
          uploaded: fileName,
          'can-upload': canUploadDocuments,
          error: isDocumentScanFailed || (isRequired && !fileName) || isDocumentFailedAfterScan,
          pending: isDocumentScanPending,
          'is-drag-over': isDragOver,
          'is-stretched': isStretched
        }"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)"
        (dragleave)="onDragLeave($event)"
      >
        <span class="upload-desktop-card-header-and-body">
          <span
            class="upload-desktop-card-body"
            [ngClass]="{
              uploaded: fileName
            }"
          >
            <span class="upload-desktop-card-header-and-body-main">
              <span class="upload-desktop-card-icon" [ngClass]="{ sm: isSm }">
                <i
                  class="fa paperclip"
                  aria-hidden="true"
                  [ngClass]="{
                    'fa-paperclip': isDocumentUploaded || !fileName,
                    'fa-times': isDocumentScanFailed || isDocumentFailedAfterScan,
                    'fa-refresh': isDocumentScanPending
                  }"
                ></i>
                <span class="upload-desktop-card-icon-successful" *ngIf="isUploadSuccessful">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </span>

                <span *ngIf="!isUploadSuccessful && isShowNormalAddIcon" class="upload-desktop-card-icon-normal">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </span>
              </span>

              <span class="upload-desktop-card-description-text">
                <span class="upload-desktop-card-header">
                  <loading-spinner [show]="isLoading || isDocumentScanPending || isUploadingDoc"></loading-spinner>

                  <span class="upload-desktop-card-header-type-name">{{ attachmentName || attachmentTypeName | translate }}</span>
                  <span class="upload-desktop-card-header-optional" *ngIf="!isRequired && !isSm && isShowOptionalTag">
                    {{ "LABELS.OPTIONAL" | translate }}
                  </span>
                  <span class="upload-desktop-card-header-required" *ngIf="isRequired && !fileName && !isSm">
                    {{ "LABELS.REQUIRED" | translate }}
                  </span>
                </span>

                <span
                  class="document-id d-none d-md-flex"
                  *ngIf="(attachmentName || attachmentHint) && !fileName && !isSm"
                  [innerHTML]="attachmentHint || attachmentName | translate"
                ></span>

                <span *ngIf="fileName" [class]="'document-file-name ' + documentFileNameBtnClass">
                  <button type="button" class="btn btn-link" (click)="downloadDocument()" [disabled]="!isDocumentUploaded">
                    {{ fileName }}
                  </button>
                  <a #link class="d-none" download></a>
                </span>

                <span class="upload-desktop-card-errors">
                  <span *ngIf="isDocumentScanFailed" class="text-error">
                    {{ "DOCUMENTS.SCAN_FAILED" | translate }}
                  </span>
                  <span *ngIf="isDocumentFailedAfterScan" class="text-error">
                    {{ "BACK_ERROR.FILE_SIZE_TO_BIG_AFTER_SCAN" | translate }}
                  </span>
                </span>

                <span
                  class="upload-desktop-card-link mt-2 d-block pl-0"
                  *ngIf="
                    (!isHidePoaDownload &&
                      [enumDocumentType.POWER_OF_ATTORNEY, enumDocumentType.POWER_OF_ATTORNEY_TRUCKER].includes(uploadedDocument?.type)) ||
                    (isShowDownloadFile && !isDocumentUploaded)
                  "
                >
                  <a [href]="poaFileUrl" target="_blank" download>
                    <span class="upload-desktop-card-download-icon-container">
                      <icon-download></icon-download>
                    </span>
                    {{ "BUTTON.DOWNLOAD_POA_FORM" | translate }}
                  </a>
                </span>
              </span>
            </span>

            <span
              class="upload-desktop-card-description-date d-none d-md-flex"
              *ngIf="
                fileName &&
                !isDocumentScanFailed &&
                !isDocumentFailedAfterScan &&
                (!!uploadedDocument?.uploadedDate || !!uploadedDocument?.createdDate)
              "
              [ngClass]="{ 'with-actions': !!fileName && canRemoveDocuments }"
            >
              {{ uploadedDocument?.uploadedDate || uploadedDocument?.createdDate | customDateByUtc }}
            </span>

            <span class="upload-desktop-card-description-actions" *ngIf="!!fileName && canRemoveDocuments">
              <span class="upload-desktop-card-remove-icon" (click)="removeFile($event)">
                <img src="assets/icons/icon_trash.svg" />
              </span>
            </span>

            <span class="upload-desktop-card-aside d-none d-md-flex" *ngIf="!fileName && canUploadDocuments && !isShowEmptyFileTag">
              <span [innerHTML]="footerHint | translate"></span>
              <app-hint-tooltip-icon [hint]="attachmentManagedTooltip" *ngIf="!!attachmentManagedTooltip"></app-hint-tooltip-icon>
            </span>

            <span class="upload-desktop-card-aside-empty" *ngIf="!fileName && isShowEmptyFileTag">
              <span [innerHTML]="'LABELS.NOT_AVAILABLE_YET' | translate"></span>
            </span>
          </span>
        </span>

        <div class="upload-desktop-card-errors-container" *ngIf="fileControl.invalid">
          <app-control-errors [errors]="errors" [control]="fileControl" [isShowHelper]="false"></app-control-errors>
        </div>
      </label>
    </div>
  </ng-template>

  <ng-template #dividedLayout>
    <div class="upload-desktop-card-layout-divided" [ngClass]="{ sm: isSm }">
      <label
        class="upload-desktop-card"
        [for]="id"
        [ngClass]="{
          empty: !fileName,
          uploaded: fileName,
          'can-upload': canUploadDocuments,
          error: isDocumentScanFailed || (isRequired && !fileName) || isDocumentFailedAfterScan,
          pending: isDocumentScanPending,
          'is-drag-over': isDragOver,
          'is-stretched': isStretched
        }"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)"
        (dragleave)="onDragLeave($event)"
      >
        <span class="upload-desktop-card-header-and-body">
          <span
            class="upload-desktop-card-body"
            [ngClass]="{
              uploaded: fileName
            }"
          >
            <span class="upload-desktop-card-header-and-body-main">
              <span class="upload-desktop-card-icon" [ngClass]="{ sm: isSm }">
                <i
                  class="fa paperclip"
                  aria-hidden="true"
                  [ngClass]="{
                    'fa-paperclip': isDocumentUploaded || !fileName,
                    'fa-times': isDocumentScanFailed || isDocumentFailedAfterScan,
                    'fa-refresh': isDocumentScanPending
                  }"
                ></i>
                <span class="upload-desktop-card-icon-successful" *ngIf="isUploadSuccessful">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </span>

                <span *ngIf="!isUploadSuccessful && isShowNormalAddIcon" class="upload-desktop-card-icon-normal">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </span>
              </span>

              <span class="upload-desktop-card-description-text">
                <span class="upload-desktop-card-header">
                  <loading-spinner [show]="isLoading || isDocumentScanPending || isUploadingDoc"></loading-spinner>

                  <span class="upload-desktop-card-header-type-name">{{ attachmentName || attachmentTypeName | translate }}</span>
                  <span class="upload-desktop-card-header-optional" *ngIf="!isRequired && !isSm && isShowOptionalTag">
                    {{ "LABELS.OPTIONAL" | translate }}
                  </span>
                  <span class="upload-desktop-card-header-required" *ngIf="isRequired && !fileName && !isSm">
                    {{ "LABELS.REQUIRED" | translate }}
                  </span>
                </span>

                <span
                  class="document-id d-none d-md-flex"
                  *ngIf="(attachmentName || attachmentHint) && !fileName && !isSm"
                  [innerHTML]="attachmentHint || attachmentName | translate"
                ></span>

                <span *ngIf="fileName" [class]="'document-file-name ' + documentFileNameBtnClass">
                  <button type="button" class="btn btn-link" (click)="downloadDocument()" [disabled]="!isDocumentUploaded">
                    {{ fileName }}
                  </button>
                  <a #link class="d-none" download></a>
                </span>

                <span class="upload-desktop-card-errors">
                  <span *ngIf="isDocumentScanFailed" class="text-error">
                    {{ "DOCUMENTS.SCAN_FAILED" | translate }}
                  </span>
                  <span *ngIf="isDocumentFailedAfterScan" class="text-error">
                    {{ "BACK_ERROR.FILE_SIZE_TO_BIG_AFTER_SCAN" | translate }}
                  </span>
                </span>
              </span>
            </span>

            <span
              class="upload-desktop-card-description-date d-none d-md-flex"
              *ngIf="
                isShowFileDate &&
                fileName &&
                !isDocumentScanFailed &&
                !isDocumentFailedAfterScan &&
                (!!uploadedDocument?.uploadedDate || !!uploadedDocument?.createdDate)
              "
              [ngClass]="{ 'with-actions': !!fileName && canRemoveDocuments }"
            >
              {{ uploadedDocument?.uploadedDate || uploadedDocument?.createdDate | customDateByUtc }}
            </span>

            <span class="upload-desktop-card-description-actions" *ngIf="!!fileName && canViewDocuments">
              <span class="upload-desktop-card-view-icon" (click)="viewFile($event)">
                <img src="assets/icons/eye_gray.svg" />
              </span>
            </span>

            <span class="upload-desktop-card-description-actions" *ngIf="!!fileName && canRemoveDocuments">
              <span class="upload-desktop-card-remove-icon" (click)="removeFile($event)">
                <img src="assets/icons/icon_trash.svg" />
              </span>
            </span>

            <span class="upload-desktop-card-description-actions" *ngIf="!!fileName && canDownloadDocuments">
              <span class="upload-desktop-card-download-icon" (click)="downloadDocument()">
                <icon-download></icon-download>
              </span>
            </span>

            <span class="upload-desktop-card-aside d-none d-md-flex" *ngIf="!fileName && canUploadDocuments && !isShowEmptyFileTag">
              <span [innerHTML]="footerHint | translate"></span>
              <app-hint-tooltip-icon [hint]="attachmentManagedTooltip" *ngIf="!!attachmentManagedTooltip"></app-hint-tooltip-icon>
            </span>

            <span class="upload-desktop-card-aside-empty" *ngIf="!fileName && isShowEmptyFileTag">
              <span [innerHTML]="'LABELS.NOT_AVAILABLE_YET' | translate"></span>
            </span>
          </span>
        </span>

        <div class="upload-desktop-card-errors-container" *ngIf="fileControl.invalid">
          <app-control-errors [errors]="errors" [control]="fileControl" [isShowHelper]="false"></app-control-errors>
        </div>
      </label>
    </div>
  </ng-template>

  <ng-template #boxLayout>
    <label
      class="upload-desktop-card upload-desktop-card-layout-box"
      [for]="id"
      [ngClass]="{
        empty: !fileName,
        uploaded: fileName,
        'can-upload': canUploadDocuments,
        error: isDocumentScanFailed || (isRequired && !fileName) || isDocumentFailedAfterScan,
        pending: isDocumentScanPending,
        'is-drag-over': isDragOver,
        'is-stretched': isStretched
      }"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
      (dragleave)="onDragLeave($event)"
    >
      <span class="upload-desktop-card-header-and-body">
        <span class="upload-desktop-card-header">
          <span class="upload-desktop-card-header-type-name">{{ attachmentName || attachmentTypeName | translate }}</span>
          <span class="upload-desktop-card-header-optional" *ngIf="!isRequired && isShowOptionalTag">
            {{ "LABELS.OPTIONAL" | translate }}
          </span>
          <span class="upload-desktop-card-header-required" *ngIf="isRequired && !fileName">{{ "LABELS.REQUIRED" | translate }}</span>
        </span>
        <span
          class="upload-desktop-card-body"
          [ngClass]="{
            uploaded: fileName
          }"
        >
          <span class="upload-desktop-card-icon">
            <i
              class="fa paperclip"
              aria-hidden="true"
              [ngClass]="{
                'fa-paperclip': isDocumentUploaded || !fileName,
                'fa-times': isDocumentScanFailed || isDocumentFailedAfterScan,
                'fa-refresh': isDocumentScanPending
              }"
            ></i>
            <span class="upload-desktop-card-icon-successful" *ngIf="isUploadSuccessful">
              <i class="fa fa-check" aria-hidden="true"></i>
            </span>

            <span *ngIf="!isUploadSuccessful && isShowNormalAddIcon" class="upload-desktop-card-icon-normal">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </span>
          </span>

          <span class="upload-desktop-card-body-description">
            <span
              class="document-id"
              *ngIf="(attachmentName || attachmentHint) && !fileName"
              [innerHTML]="attachmentHint || attachmentName | translate"
            ></span>

            <span *ngIf="fileName" [class]="'document-file-name ' + documentFileNameBtnClass">
              <button type="button" class="btn btn-link" (click)="downloadDocument()" [disabled]="!isDocumentUploaded">
                {{ fileName }}
              </button>
              <a #link class="d-none" download></a>
            </span>

            <loading-spinner [show]="isLoading || isDocumentScanPending || isUploadingDoc"></loading-spinner>
          </span>

          <span *ngIf="!!fileName && canRemoveDocuments" class="upload-desktop-card-remove">
            <span class="upload-desktop-card-remove-icon" (click)="removeFile($event)">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </span>
          </span>
        </span>
        <span
          class="upload-desktop-card-link"
          *ngIf="
            [enumDocumentType.POWER_OF_ATTORNEY, enumDocumentType.POWER_OF_ATTORNEY_TRUCKER].includes(uploadedDocument?.type) ||
            (isShowDownloadFile && !isDocumentUploaded)
          "
        >
          <a [href]="poaFileUrl" target="_blank" download>
            <span class="upload-desktop-card-download-icon-container">
              <icon-download></icon-download>
            </span>
            {{ "BUTTON.DOWNLOAD_POA_FORM_BLANK" | translate }}
          </a>
        </span>
        <span class="upload-desktop-card-errors">
          <span *ngIf="isDocumentScanFailed" class="text-error">
            {{ "DOCUMENTS.SCAN_FAILED" | translate }}
          </span>
          <span *ngIf="isDocumentFailedAfterScan" class="text-error">
            {{ "BACK_ERROR.FILE_SIZE_TO_BIG_AFTER_SCAN" | translate }}
          </span>
        </span>
      </span>

      <span class="upload-desktop-card-footer" *ngIf="!fileName && isShowFooter">
        <span [innerHTML]="footerHint | translate"></span>
      </span>
      <div class="upload-desktop-card-errors-container">
        <app-control-errors [errors]="errors" [control]="fileControl" [isShowHelper]="false"></app-control-errors>
      </div>
    </label>
  </ng-template>

  <!--TODO: need to get task for creating one uploader!-->
  <ng-template #mobileDividedLayout>
    <div class="mobile-layout-divided" [ngClass]="{ sm: isSm }">
      <label
        class="upload-desktop-card"
        [for]="id"
        [ngClass]="{
          empty: !fileName,
          uploaded: fileName,
          'can-upload': canUploadDocuments,
          error: isDocumentScanFailed || isDocumentFailedAfterScan,
          pending: isDocumentScanPending,
          'is-drag-over': isDragOver,
          'is-stretched': isStretched
        }"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)"
        (dragleave)="onDragLeave($event)"
      >
        <span
          class="d-flex"
          [ngClass]="{
            uploaded: fileName
          }"
        >
          <span class="d-flex flex-column w-100 p-3">
            <loading-spinner [show]="isLoading || isDocumentScanPending || isUploadingDoc"></loading-spinner>
            <div class="d-flex align-content-center justify-content-between pb-2">
              <span class="upload-desktop-card-header-type-name">{{ attachmentName || attachmentTypeName | translate }}</span>
              <span
                class="upload-desktop-card-header-optional"
                *ngIf="!isRequired && !isSm && isShowOptionalTag && !fileName && !isShowDeferredRequiredTag"
              >
                {{ "LABELS.OPTIONAL" | translate }}
              </span>
              <span class="upload-desktop-card-header-required-later" *ngIf="isShowDeferredRequiredTag && !fileName && !isRequired">
                {{ "LABELS.REQUIRED_LATER" | translate }}
                <app-hint-tooltip-icon
                  *ngIf="requiredLaterTooltip"
                  [hint]="requiredLaterTooltip | translate"
                  (click)="onRequiredLaterTooltipClick($event)"
                ></app-hint-tooltip-icon>
              </span>
              <span class="upload-desktop-card-header-required" *ngIf="isRequired && !fileName && !isSm">
                {{ "LABELS.REQUIRED" | translate }}
              </span>
            </div>
            <div class="d-flex">
              <span class="d-flex w-100 align-items-center">
                <span class="upload-desktop-card-icon" [ngClass]="{ sm: isSm }">
                  <i
                    class="fa paperclip"
                    aria-hidden="true"
                    [ngClass]="{
                      'fa-check': isDocumentUploaded,
                      'fa-plus': !fileName,
                      'fa-times': isDocumentScanFailed || isDocumentFailedAfterScan,
                      'fa-refresh': isDocumentScanPending
                    }"
                  ></i>
                </span>

                <span class="upload-desktop-card-description-text">
                  <span
                    class="document-id d-flex"
                    *ngIf="(attachmentName || attachmentHint) && !fileName && !isSm"
                    [innerHTML]="attachmentHint || attachmentName | translate"
                  ></span>

                  <span *ngIf="fileName" [class]="'document-file-name ' + documentFileNameBtnClass">
                    <button type="button" class="btn btn-link" (click)="downloadDocument()" [disabled]="!isDocumentUploaded">
                      {{ fileName }}
                    </button>
                    <a #link class="d-none" download></a>
                  </span>

                  <span class="upload-desktop-card-errors">
                    <span *ngIf="isDocumentScanFailed" class="text-error">
                      {{ "DOCUMENTS.SCAN_FAILED" | translate }}
                    </span>
                    <span *ngIf="isDocumentFailedAfterScan" class="text-error">
                      {{ "BACK_ERROR.FILE_SIZE_TO_BIG_AFTER_SCAN" | translate }}
                    </span>
                  </span>
                </span>
              </span>

              <span class="upload-desktop-card-aside d-none d-md-flex" *ngIf="!fileName && canUploadDocuments && !isShowEmptyFileTag">
                <span [innerHTML]="footerHint | translate"></span>
                <app-hint-tooltip-icon [hint]="attachmentManagedTooltip" *ngIf="!!attachmentManagedTooltip"></app-hint-tooltip-icon>
              </span>

              <span class="upload-desktop-card-aside-empty" *ngIf="!fileName && isShowEmptyFileTag">
                <span [innerHTML]="'LABELS.NOT_AVAILABLE_YET' | translate"></span>
              </span>
            </div>
            <div
              class="upload-desktop-card-link p-0"
              *ngIf="
                ([enumDocumentType.POWER_OF_ATTORNEY, enumDocumentType.POWER_OF_ATTORNEY_TRUCKER].includes(uploadedDocument?.type) &&
                  !fileName) ||
                (isShowDownloadFile && !isDocumentUploaded)
              "
            >
              <a [href]="poaFileUrl" target="_blank" download>
                <span class="upload-desktop-card-download-icon-container">
                  <icon-download></icon-download>
                </span>
                {{ "BUTTON.DOWNLOAD_POA_FORM" | translate }}
              </a>
            </div>
          </span>
          <div class="upload-desktop-card-description-actions">
            <span class="upload-desktop-card-download-icon" *ngIf="!!fileName && isDownloadOnlyAction" (click)="downloadDocument($event)">
              <icon-download></icon-download>
            </span>
            <dropdown-action
              [menuMode]="menuMode"
              *ngIf="!!fileName && (canViewDocuments || canDownloadDocuments || canRemoveDocuments) && !isDownloadOnlyAction"
              className="m-0"
            >
              <button dropdown-item class="dropdown-item" (click)="viewFile($event)" *ngIf="!!fileName && canViewDocuments">
                <img src="assets/icons/eye_gray.svg" class="upload-desktop-card-view-icon mr-2" />
                {{ "BUTTON.VIEW" | translate }}
              </button>
              <button dropdown-item class="dropdown-item" (click)="removeFile($event)" *ngIf="!!fileName && canRemoveDocuments">
                <img src="assets/icons/icon_trash.svg" class="upload-desktop-card-remove-icon mr-2" />
                {{ "BUTTON.DELETE" | translate }}
              </button>
              <button
                dropdown-item
                class="dropdown-item"
                style="display: flex"
                (click)="downloadDocument()"
                *ngIf="!!fileName && canDownloadDocuments"
              >
                <div class="upload-desktop-card-download-icon mr-2" style="height: 20px; width: 20px; color: #7a7a7a">
                  <icon-download></icon-download>
                </div>
                {{ "BUTTON.DOWNLOAD" | translate }}
              </button>
            </dropdown-action>
          </div>
        </span>

        <div class="upload-desktop-card-errors-container" *ngIf="fileControl.invalid">
          <app-control-errors [errors]="errors" [control]="fileControl" [isShowHelper]="false"></app-control-errors>
        </div>
        <div>
          <span class="upload-desktop-card-footer" *ngIf="!fileName && !!isShowFooter">
            <span [innerHTML]="footerHint | translate"></span>
          </span>
        </div>
      </label>
    </div>
  </ng-template>

  <ng-template #mobileBoxLayout>
    <div class="mobile-layout" [ngClass]="{ sm: isSm }">
      <label
        class="upload-desktop-card"
        [for]="id"
        [ngClass]="{
          empty: !fileName,
          uploaded: fileName,
          'can-upload': canUploadDocuments,
          error: isDocumentScanFailed || (isRequired && !fileName) || isDocumentFailedAfterScan,
          pending: isDocumentScanPending,
          'is-drag-over': isDragOver,
          'is-stretched': isStretched
        }"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)"
        (dragleave)="onDragLeave($event)"
      >
        <span
          class="d-flex"
          [ngClass]="{
            uploaded: fileName
          }"
        >
          <span class="d-flex flex-column w-100 p-3">
            <loading-spinner [show]="isLoading || isDocumentScanPending || isUploadingDoc"></loading-spinner>
            <div class="d-flex align-content-center justify-content-between pb-2">
              <span class="upload-desktop-card-header-type-name">{{ attachmentName || attachmentTypeName | translate }}</span>
              <span
                class="upload-desktop-card-header-optional"
                *ngIf="!isRequired && !isSm && isShowOptionalTag && !fileName && !isShowDeferredRequiredTag"
              >
                {{ "LABELS.OPTIONAL" | translate }}
              </span>
              <span class="upload-desktop-card-header-required-later" *ngIf="isShowDeferredRequiredTag && !fileName && !isRequired">
                {{ "LABELS.REQUIRED_LATER" | translate }}
                <app-hint-tooltip-icon
                  *ngIf="requiredLaterTooltip"
                  [hint]="requiredLaterTooltip | translate"
                  (click)="onRequiredLaterTooltipClick($event)"
                ></app-hint-tooltip-icon>
              </span>
              <span class="upload-desktop-card-header-required" *ngIf="isRequired && !fileName && !isSm">
                {{ "LABELS.REQUIRED" | translate }}
              </span>
            </div>
            <div class="d-flex">
              <span class="d-flex w-100 align-items-center">
                <span class="upload-desktop-card-icon" [ngClass]="{ sm: isSm }">
                  <i
                    class="fa paperclip"
                    aria-hidden="true"
                    [ngClass]="{
                      'fa-check': isDocumentUploaded,
                      'fa-plus': !fileName,
                      'fa-times': isDocumentScanFailed || isDocumentFailedAfterScan,
                      'fa-refresh': isDocumentScanPending
                    }"
                  ></i>
                </span>

                <span class="upload-desktop-card-description-text">
                  <span
                    class="document-id d-flex"
                    *ngIf="(attachmentName || attachmentHint) && !fileName && !isSm"
                    [innerHTML]="attachmentHint || attachmentName | translate"
                  ></span>

                  <span *ngIf="fileName" [class]="'document-file-name ' + documentFileNameBtnClass">
                    <button type="button" class="btn btn-link" (click)="downloadDocument()" [disabled]="!isDocumentUploaded">
                      {{ fileName }}
                    </button>
                    <a #link class="d-none" download></a>
                  </span>

                  <span
                    class="uploaded-date-label"
                    *ngIf="fileName && !isDocumentScanFailed && !isDocumentFailedAfterScan && !!uploadedDocument?.uploadedDate"
                    [ngClass]="{ 'with-actions': !!fileName && canRemoveDocuments }"
                  >
                    {{ uploadedDocument?.uploadedDate | customDateByUtc }}
                  </span>

                  <span class="upload-desktop-card-errors">
                    <span *ngIf="isDocumentScanFailed" class="text-error">
                      {{ "DOCUMENTS.SCAN_FAILED" | translate }}
                    </span>
                    <span *ngIf="isDocumentFailedAfterScan" class="text-error">
                      {{ "BACK_ERROR.FILE_SIZE_TO_BIG_AFTER_SCAN" | translate }}
                    </span>
                  </span>
                </span>
              </span>

              <span class="upload-desktop-card-description-actions" *ngIf="!!fileName && canRemoveDocuments">
                <span class="upload-desktop-card-remove-icon" (click)="removeFile($event)">
                  <img src="assets/icons/icon_trash.svg" />
                </span>
              </span>

              <span class="upload-desktop-card-aside d-none d-md-flex" *ngIf="!fileName && canUploadDocuments && !isShowEmptyFileTag">
                <span [innerHTML]="footerHint | translate"></span>
                <app-hint-tooltip-icon [hint]="attachmentManagedTooltip" *ngIf="!!attachmentManagedTooltip"></app-hint-tooltip-icon>
              </span>

              <span class="upload-desktop-card-aside-empty" *ngIf="!fileName && isShowEmptyFileTag">
                <span [innerHTML]="'LABELS.NOT_AVAILABLE_YET' | translate"></span>
              </span>
            </div>
            <div
              class="upload-desktop-card-link p-0"
              *ngIf="
                ([enumDocumentType.POWER_OF_ATTORNEY, enumDocumentType.POWER_OF_ATTORNEY_TRUCKER].includes(uploadedDocument?.type) &&
                  !fileName) ||
                (isShowDownloadFile && !isDocumentUploaded)
              "
            >
              <a [href]="poaFileUrl" target="_blank" download>
                <span class="upload-desktop-card-download-icon-container">
                  <icon-download></icon-download>
                </span>
                {{ "BUTTON.DOWNLOAD_POA_FORM" | translate }}
              </a>
            </div>
          </span>
        </span>

        <div class="upload-desktop-card-errors-container" *ngIf="fileControl.invalid">
          <app-control-errors [errors]="errors" [control]="fileControl" [isShowHelper]="false"></app-control-errors>
        </div>
        <div>
          <span class="upload-desktop-card-footer" *ngIf="!fileName && isShowFooter">
            <span [innerHTML]="footerHint | translate"></span>
          </span>
        </div>
      </label>
    </div>
  </ng-template>

  <input
    #inputElement
    class="d-none"
    type="file"
    [id]="id"
    [accept]="allowedFileMimes"
    (click)="clickInput()"
    (change)="handleFiles($event)"
    [disabled]="(isDocumentUploaded && !!fileName) || !canUploadDocuments || isLoading || isDocumentScanPending || isUploadingDoc"
  />
</ng-template>
